import React, { Component, Fragment } from 'react';
import MetaTags from "react-meta-tags";
import Header from '../layouts/Header';
import Footer from '../layouts/Footer';
import Breadcrumb from '../layouts/Breadcrumb';
import Content from '../sections/trasee/Content';
import { useTranslation } from 'react-i18next';

const pagelocation = 'meniu.trasee'
const pagetext = 'Trasee'

function Trasee() {
    const { t, i18n } = useTranslation();
    return (
        <Fragment>
            <MetaTags>
                <title>Super Imposer | {i18n.t(pagelocation)}</title>
                <meta
                    name="description"
                    content="Super Imposer - transport persoane intern și internațional"
                    />
            </MetaTags>
            {/* <Header headercolor="black" /> */}
            <Breadcrumb breadcrumb={{ pagename: pagelocation, 
                                        pagetitle: pagetext, 
                                        bgImage: '' ,
                                        subtitlu: 'banner.subtitlu' }} />
            <Content/>
            {/* <Footer/> */}
            {/* <Footer footer={{ style:"", logo:"assets/img/footer-logo.png" }}/> */}
        </Fragment>
    );
}

export default Trasee;